import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import PropTypes$1 from 'prop-types';
import { __assign } from 'tslib';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import uniqWith from 'lodash/uniqWith';
import sortBy from 'lodash/sortBy';
import _inherits from '@babel/runtime/helpers/inherits';
import _createSuper from '@babel/runtime/helpers/createSuper';
import EventEmitter from 'wolfy87-eventemitter';
import 'lodash/isNumber';
import '@babel/runtime/helpers/regeneratorRuntime';
import '@babel/runtime/helpers/asyncToGenerator';
import 'react';
import isString from 'lodash/isString';
import 'tinycolor2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import 'slugify';
import uniqBy from 'lodash/uniqBy';
import _typeof from '@babel/runtime/helpers/typeof';
import uniq from 'lodash/uniq';
import isEmpty from 'lodash/isEmpty';
import { Tracking as Tracking$1 } from '@folklore/tracking';

/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
/**
 * Lower case as a function.
 */
function lowerCase(str) {
  return str.toLowerCase();
}

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */
function noCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.splitRegexp,
    splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a,
    _b = options.stripRegexp,
    stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b,
    _c = options.transform,
    transform = _c === void 0 ? lowerCase : _c,
    _d = options.delimiter,
    delimiter = _d === void 0 ? " " : _d;
  var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
  var start = 0;
  var end = result.length;
  // Trim the delimiter from around the output string.
  while (result.charAt(start) === "\0") start++;
  while (result.charAt(end - 1) === "\0") end--;
  // Transform each token independently.
  return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
  if (re instanceof RegExp) return input.replace(re, value);
  return re.reduce(function (input, re) {
    return input.replace(re, value);
  }, input);
}

function dotCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  return noCase(input, __assign({
    delimiter: "."
  }, options));
}

function snakeCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  return dotCase(input, __assign({
    delimiter: "_"
  }, options));
}

/**
 * Core
 */
var history = PropTypes$1.shape({
  listen: PropTypes$1.func.isRequired,
  push: PropTypes$1.func.isRequired
});
var location = PropTypes$1.shape({
  pathname: PropTypes$1.string,
  search: PropTypes$1.string
});
var intl = PropTypes$1.shape({
  locale: PropTypes$1.string.isRequired,
  formatMessage: PropTypes$1.func.isRequired
});
var defaultMessageContent = PropTypes$1.shape({
  type: PropTypes$1.number,
  value: PropTypes$1.string
});
var defaultMessage = PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(defaultMessageContent)]);
var message = PropTypes$1.shape({
  id: PropTypes$1.string,
  defaultMessage: defaultMessage.isRequired,
  description: PropTypes$1.string
});
var text = PropTypes$1.oneOfType([message, PropTypes$1.string]);
var label = PropTypes$1.oneOfType([message, PropTypes$1.node]);
var statusCode = PropTypes$1.oneOf([401, 403, 404, 500]);
var ref = PropTypes$1.oneOfType([PropTypes$1.shape({
  current: PropTypes$1.any // eslint-disable-line react/forbid-prop-types
}), PropTypes$1.func]);
var target = PropTypes$1.oneOf(['_blank', '_self', '_parent']);
var interaction = PropTypes$1.oneOf(['tap', 'swipe']);
var interactions = PropTypes$1.arrayOf(interaction);
var trackingVariables = PropTypes$1.objectOf(PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number, PropTypes$1.array]));
var progress = PropTypes$1.shape({
  currentTime: PropTypes$1.number,
  duration: PropTypes$1.number
});

/**
 * Site
 */
var user = PropTypes$1.shape({
  id: PropTypes$1.number,
  firstname: PropTypes$1.string,
  lastname: PropTypes$1.string,
  email: PropTypes$1.string,
  gender: PropTypes$1.string,
  birthdate: PropTypes$1.string
});
var menuItem = PropTypes$1.shape({
  id: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  label: label,
  url: PropTypes$1.string,
  external: PropTypes$1.bool,
  active: PropTypes$1.bool
});
var menuItems = PropTypes$1.arrayOf(menuItem);
var breadcrumb = PropTypes$1.shape({
  label: label,
  url: PropTypes$1.string
});
var breadcrumbs = PropTypes$1.arrayOf(breadcrumb);
var device = PropTypes$1.shape({
  id: PropTypes$1.string.isRequired
});
var devices = PropTypes$1.arrayOf(device);
var modal = PropTypes$1.shape({
  id: PropTypes$1.string.isRequired
});
var modals = PropTypes$1.arrayOf(modal);
var panel = PropTypes$1.shape({
  id: PropTypes$1.string.isRequired
});
var panels = PropTypes$1.arrayOf(panel);
var button = PropTypes$1.shape({
  label: label,
  onClick: PropTypes$1.func
});
var buttons = PropTypes$1.arrayOf(button);
var bootstrapThemeStrings = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'];
var bootstrapThemes = PropTypes$1.oneOf(bootstrapThemeStrings);
var buttonTheme = PropTypes$1.oneOf([].concat(bootstrapThemeStrings, ['outline-primary', 'outline-secondary', 'outline-success', 'outline-danger', 'outline-warning', 'outline-info', 'outline-light', 'outline-dark', 'outline-link', null]));
var buttonSize = PropTypes$1.oneOf(['lg', 'sm', null]);
var formControlSize = PropTypes$1.oneOf(['lg', 'sm', null]);
var dropdownAlign = PropTypes$1.oneOf(['start', 'end']);
var componentNames = function componentNames(Components) {
  return PropTypes$1.oneOf(Object.keys(Components).map(function (it) {
    return snakeCase(it);
  }));
};
var component = PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.func]);
var components = PropTypes$1.objectOf(component);

/**
 * Forms
 */
var errors = PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.string)]);
var formErrors = PropTypes$1.objectOf(errors);
var selectOption = PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.shape({
  value: PropTypes$1.any,
  // eslint-disable-line
  label: label
})]);
var selectOptions = PropTypes$1.arrayOf(selectOption);
var formField = PropTypes$1.shape({
  name: PropTypes$1.string,
  component: component
});
var formFields = PropTypes$1.arrayOf(formField);

/**
 * Medias
 */
var mediaMetadataShape = {
  filename: PropTypes$1.string,
  size: PropTypes$1.number,
  mime: PropTypes$1.string
};
var mediaFile = PropTypes$1.shape({
  id: PropTypes$1.string,
  handle: PropTypes$1.string,
  type: PropTypes$1.string,
  mime: PropTypes$1.string,
  url: PropTypes$1.string
});
var mediaShape = {
  id: PropTypes$1.string,
  type: PropTypes$1.string.isRequired,
  url: PropTypes$1.string,
  // .isRequired,
  thumbnail_url: PropTypes$1.string,
  name: PropTypes$1.string,
  metadata: PropTypes$1.shape(_objectSpread({}, mediaMetadataShape)),
  files: PropTypes$1.objectOf(mediaFile)
};
var media = PropTypes$1.shape(mediaShape);
var medias = PropTypes$1.arrayOf(media);
var mediaTypes = PropTypes$1.oneOf(['image', 'video', 'audio', 'closed-captions', 'font']);
var imageMedia = PropTypes$1.shape(_objectSpread(_objectSpread({}, mediaShape), {}, {
  type: PropTypes$1.oneOf(['image', 'video']),
  metadata: PropTypes$1.shape(_objectSpread(_objectSpread({}, mediaMetadataShape), {}, {
    width: PropTypes$1.number,
    height: PropTypes$1.number
  }))
}));
var imageMedias = PropTypes$1.arrayOf(imageMedia);
var fontMedia = PropTypes$1.shape(_objectSpread(_objectSpread({}, mediaShape), {}, {
  type: PropTypes$1.oneOf(['font']),
  metadata: PropTypes$1.shape(_objectSpread({}, mediaMetadataShape))
}));
var fontMedias = PropTypes$1.arrayOf(fontMedia);
var videoMedia = PropTypes$1.shape(_objectSpread(_objectSpread({}, mediaShape), {}, {
  type: PropTypes$1.oneOf(['video']),
  metadata: PropTypes$1.shape(_objectSpread(_objectSpread({}, mediaMetadataShape), {}, {
    width: PropTypes$1.number,
    height: PropTypes$1.number,
    duration: PropTypes$1.number
  }))
}));
var videoMedias = PropTypes$1.arrayOf(videoMedia);
var audioMedia = PropTypes$1.shape(_objectSpread(_objectSpread({}, mediaShape), {}, {
  type: PropTypes$1.oneOf(['audio']),
  metadata: PropTypes$1.shape(_objectSpread(_objectSpread({}, mediaMetadataShape), {}, {
    duration: PropTypes$1.number
  }))
}));
var audioMedias = PropTypes$1.arrayOf(audioMedia);
var closedCaptionsMedia = PropTypes$1.shape(_objectSpread(_objectSpread({}, mediaShape), {}, {
  type: PropTypes$1.oneOf(['closed-captions'])
}));

/**
 * Style
 */

var customFont = PropTypes$1.shape({
  type: PropTypes$1.oneOf(['system', 'google', 'custom']),
  name: PropTypes$1.string,
  media: fontMedia
});
var font = PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.string]);
var fonts = PropTypes$1.arrayOf(font);
var textAlign = PropTypes$1.oneOf(['left', 'right', 'center']);
var color = PropTypes$1.shape({
  color: PropTypes$1.string,
  alpha: PropTypes$1.number
});
var textStyle = PropTypes$1.shape({
  fontFamily: font,
  fontSize: PropTypes$1.number,
  fontStyle: PropTypes$1.shape({
    bold: PropTypes$1.bool,
    italic: PropTypes$1.bool,
    underline: PropTypes$1.bool,
    upperCase: PropTypes$1.bool
  }),
  align: textAlign,
  color: color,
  letterSpacing: PropTypes$1.number,
  lineHeight: PropTypes$1.number
});
var borderTypes = PropTypes$1.oneOf(['dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset', 'hidden']);
var shadowType = PropTypes$1.shape({
  shadowDistance: PropTypes$1.number,
  shadowBlur: PropTypes$1.number,
  shadowColor: color
});
var borderStyle = PropTypes$1.shape({
  width: PropTypes$1.number,
  style: borderTypes,
  radius: PropTypes$1.number,
  color: color
});
var boxStyle = PropTypes$1.shape({
  backgroundColor: color,
  borderRadius: PropTypes$1.number,
  borderWidth: PropTypes$1.number,
  borderColor: color,
  borderStyle: borderTypes,
  shadow: shadowType
});
var margin = PropTypes$1.shape({
  top: PropTypes$1.number,
  bottom: PropTypes$1.number
});
var gridLayout = PropTypes$1.arrayOf(PropTypes$1.shape({
  rows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.arrayOf(PropTypes$1.number)]),
  columns: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.arrayOf(PropTypes$1.number)])
}));
var objectFitSize = PropTypes$1.oneOf(['cover', 'contain', null]);
var objectFit = PropTypes$1.shape({
  fit: objectFitSize,
  horizontalPosition: PropTypes$1.oneOf(['left', 'center', 'right']),
  verticalPosition: PropTypes$1.oneOf(['top', 'center', 'bottom'])
});

/**
 * Elements
 */

var textElement = PropTypes$1.shape({
  body: PropTypes$1.string,
  textStyle: textStyle
});
var headingElement = textElement;
var inputElement = PropTypes$1.shape({
  label: PropTypes$1.string,
  textStyle: textStyle
});
var imageElement = PropTypes$1.shape({
  media: imageMedia
});
var imageElements = PropTypes$1.arrayOf(imageElement);
var videoElement = PropTypes$1.shape({
  media: videoMedia,
  autoPlay: PropTypes$1.bool,
  loop: PropTypes$1.bool,
  closedCaptions: closedCaptionsMedia,
  withSeekBar: PropTypes$1.bool,
  withControls: PropTypes$1.bool
});
var visualElement = PropTypes$1.shape({
  media: imageMedia
});
var visualElements = PropTypes$1.arrayOf(visualElement);
var audioElement = PropTypes$1.shape({
  media: audioMedia,
  autoPlay: PropTypes$1.bool,
  loop: PropTypes$1.bool,
  closedCaptions: closedCaptionsMedia,
  withPlayPause: PropTypes$1.bool
});
var closedCaptionsElement = PropTypes$1.shape({
  media: closedCaptionsMedia
});
var backgroundElement = PropTypes$1.shape({
  color: color,
  image: imageMedia,
  video: videoMedia
});
var imageElementWithCaption = PropTypes$1.shape({
  image: imageMedia,
  caption: textElement
});
var imageElementsWithCaption = PropTypes$1.arrayOf(imageElementWithCaption);
var stackDirection = PropTypes$1.oneOf(['horizontal', 'vertical']);
var stackAlign = PropTypes$1.oneOf(['start', 'center', 'end']);
var stackSpacing = PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.oneOf(['between', 'evenly', 'around'])]);
var stackElement = PropTypes$1.shape({
  direction: stackDirection,
  align: stackAlign,
  width: PropTypes$1.number,
  height: PropTypes$1.number,
  spacing: stackSpacing,
  reverse: PropTypes$1.bool
});
var gridElement = PropTypes$1.shape({
  layout: PropTypes$1.arrayOf(PropTypes$1.string),
  spacing: PropTypes$1.number
});
var geoPosition = PropTypes$1.shape({
  lat: PropTypes$1.number,
  lng: PropTypes$1.number
});
var markerShape = {
  id: PropTypes$1.number,
  geoPosition: geoPosition,
  title: headingElement,
  subtitle: headingElement,
  description: textElement
};
var marker = PropTypes$1.shape(_objectSpread({}, markerShape));
var markers = PropTypes$1.arrayOf(marker);
var markerWithImage = PropTypes$1.shape(_objectSpread(_objectSpread({}, markerShape), {}, {
  image: imageMedia
}));
var markersWithImage = PropTypes$1.arrayOf(markerWithImage);
var answerShape = {
  id: PropTypes$1.string,
  label: textElement
};
var answer = PropTypes$1.shape(_objectSpread({}, answerShape));
var quizAnswer = PropTypes$1.shape(_objectSpread(_objectSpread({}, answerShape), {}, {
  good: PropTypes$1.bool
}));
var answers = PropTypes$1.arrayOf(answer);
var quizAnswers = PropTypes$1.arrayOf(quizAnswer);
var callToActionTypes = PropTypes$1.oneOf(['swipe-up', 'button']);
var callToAction = PropTypes$1.shape({
  active: PropTypes$1.bool,
  type: callToActionTypes,
  url: PropTypes$1.string,
  label: textElement,
  buttonStyle: boxStyle
});
var shareIncentive = PropTypes$1.shape({
  active: PropTypes$1.bool,
  label: textElement,
  boxStyle: boxStyle
});
var activeForm = PropTypes$1.shape({
  active: PropTypes$1.bool
});
var speaker = PropTypes$1.shape({
  id: PropTypes$1.string,
  name: PropTypes$1.string,
  avatar: imageMedia,
  side: PropTypes$1.oneOf(['left', 'right']),
  color: color
});
var speakers = PropTypes$1.arrayOf(speaker);
var conversationMessage = PropTypes$1.shape({
  speaker: PropTypes$1.string,
  message: PropTypes$1.string,
  image: imageMedia,
  audio: audioMedia,
  timingOverrides: PropTypes$1.shape({
    enabled: PropTypes$1.bool,
    appearDelay: PropTypes$1.number,
    writingStateDuration: PropTypes$1.number
  })
});
var conversationMessages = PropTypes$1.arrayOf(conversationMessage);
var conversation = PropTypes$1.shape({
  speakers: speakers,
  textStyle: textStyle,
  messages: conversationMessages
});

/**
 * Definitions
 */

var fieldShape = {
  name: PropTypes$1.string,
  type: PropTypes$1.string.isRequired,
  label: text
};
var field = PropTypes$1.shape(_objectSpread(_objectSpread({}, fieldShape), {}, {
  isSection: PropTypes$1.bool,
  fields: PropTypes$1.arrayOf(PropTypes$1.shape(fieldShape))
}));
var fields = PropTypes$1.arrayOf(field);
var screenDefinition = PropTypes$1.shape({
  id: PropTypes$1.string.isRequired,
  type: PropTypes$1.oneOf(['screen']).isRequired,
  title: text.isRequired,
  layouts: PropTypes$1.arrayOf(PropTypes$1.string),
  fields: fields
});
var screenDefinitions = PropTypes$1.arrayOf(screenDefinition);
var fieldDefinition = PropTypes$1.shape({
  id: PropTypes$1.string.isRequired,
  type: PropTypes$1.oneOf(['field']).isRequired,
  title: text.isRequired,
  fields: fields
});
var fieldDefinitions = PropTypes$1.arrayOf(fieldDefinition);

/**
 * Components
 */
var storyComponentShape = {
  type: PropTypes$1.string.isRequired
};
var storyComponent = PropTypes$1.shape(_objectSpread({}, storyComponentShape));
var storyComponents = PropTypes$1.arrayOf(storyComponent);
var screenComponent = PropTypes$1.shape(_objectSpread({}, storyComponentShape));
var screenComponents = PropTypes$1.arrayOf(screenComponent);
var screen = screenComponent; // @NOTE should be removed

/**
 * Theme
 */
var theme = PropTypes$1.shape({
  id: PropTypes$1.string,
  textStyles: PropTypes$1.objectOf(textStyle),
  // renamed to textstyles
  background: backgroundElement,
  colors: PropTypes$1.objectOf(color),
  components: screenComponents
});
var viewerTheme = PropTypes$1.shape(_objectSpread({
  logo: imageMedia
}, theme));

/**
 * Branding
 */

// export const branding = PropTypes.shape({
//     logo: imageMedia,
//     primaryColor: color,
//     secondaryColor: color,
//     backgroundColor: color,
//     textStyle,
// });

/**
 * Metadata
 */
var metadata = PropTypes$1.shape({
  description: PropTypes$1.string,
  shareUrl: PropTypes$1.string,
  shareImage: imageMedia,
  favIcon: imageMedia
});
var tag = PropTypes$1.shape({
  label: PropTypes$1.string,
  value: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string])
});
var tags = PropTypes$1.arrayOf(tag);

/**
 * Story
 */
var story = PropTypes$1.shape({
  id: PropTypes$1.string,
  theme: theme,
  components: screenComponents,
  metadata: metadata
});

/**
 * Render
 */
var deviceScreen = PropTypes$1.shape({
  name: PropTypes$1.string.isRequired,
  mediaQuery: PropTypes$1.string
});
var deviceScreens = PropTypes$1.arrayOf(deviceScreen);
var screenSize = PropTypes$1.shape({
  screen: PropTypes$1.string,
  screens: PropTypes$1.arrayOf(PropTypes$1.string),
  width: PropTypes$1.number,
  height: PropTypes$1.number,
  landscape: PropTypes$1.bool
});
var renderContext = PropTypes$1.oneOf(['view', 'placeholder', 'edit', 'preview', 'static', 'capture']);

/**
 * Screens
 */

var adFormats = PropTypes$1.shape({
  width: PropTypes$1.number,
  height: PropTypes$1.number
});
var adFormat = PropTypes$1.shape({
  width: PropTypes$1.number,
  height: PropTypes$1.number,
  url: PropTypes$1.string,
  target: target,
  iframe: PropTypes$1.string,
  image: imageMedia
});
var audioComponent = PropTypes$1.shape({
  src: PropTypes$1.string,
  track: PropTypes$1.string,
  trackLng: PropTypes$1.number,
  controls: PropTypes$1.bool
});
var slide = PropTypes$1.shape({
  image: imageMedia,
  text: PropTypes$1.string
});
var slides = PropTypes$1.arrayOf(slide);

// export const imageStyle = PropTypes.shape({
//     alt: PropTypes.string,
//     fit: PropTypes.object,
// });

var containerStyle = PropTypes$1.shape({});

/**
 * Transitions
 */

var transitionName = PropTypes$1.oneOf(['fade', 'scale', 'slide']);
var transitionParams = {
  duration: PropTypes$1.number,
  easing: PropTypes$1.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
};
var transition = PropTypes$1.oneOfType([transitionName.isRequired, PropTypes$1.shape(_objectSpread({
  name: transitionName.isRequired
}, transitionParams))]);
var transitions = PropTypes$1.shape({
  "in": transition,
  out: transition
});

/**
 * Search
 */

var searchFilter = PropTypes$1.shape({
  type: PropTypes$1.string,
  value: PropTypes$1.oneOf([PropTypes$1.string, PropTypes$1.number])
});
var searchFilters = PropTypes$1.arrayOf(searchFilter);

/**
 * Payments
 */

var paymentItem = PropTypes$1.shape({
  id: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  date: PropTypes$1.string,
  type: PropTypes$1.string,
  invoice_link: PropTypes$1.string,
  amount: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])
});
var paymentItems = PropTypes$1.arrayOf(paymentItem);

/**
 * Page Metadada
 */

var pageMetadata = PropTypes$1.shape({
  canonical: PropTypes$1.string,
  description: PropTypes$1.string,
  keywords: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.array]),
  image: PropTypes$1.shape({
    url: PropTypes$1.string
  }),
  favicon: PropTypes$1.shape({
    url: PropTypes$1.string
  }),
  rssUrl: PropTypes$1.string,
  atomUrl: PropTypes$1.string,
  microformats: PropTypes$1.arrayOf(PropTypes$1.shape({}))
});
var authorElement = PropTypes$1.shape({
  name: textElement,
  avatar: PropTypes$1.shape({
    url: PropTypes$1.string
  })
});
var visitor = PropTypes$1.shape({
  id: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  name: PropTypes$1.string
});
var badge = PropTypes$1.shape({
  label: textElement,
  buttonStyle: boxStyle
});
var header = PropTypes$1.shape({
  badge: badge
});
var footer = PropTypes$1.shape({
  callToAction: callToAction
});
var reload = PropTypes$1.shape();

var PropTypes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    activeForm: activeForm,
    adFormat: adFormat,
    adFormats: adFormats,
    answer: answer,
    answerShape: answerShape,
    answers: answers,
    audioComponent: audioComponent,
    audioElement: audioElement,
    audioMedia: audioMedia,
    audioMedias: audioMedias,
    authorElement: authorElement,
    backgroundElement: backgroundElement,
    badge: badge,
    bootstrapThemes: bootstrapThemes,
    borderStyle: borderStyle,
    borderTypes: borderTypes,
    boxStyle: boxStyle,
    breadcrumb: breadcrumb,
    breadcrumbs: breadcrumbs,
    button: button,
    buttonSize: buttonSize,
    buttonTheme: buttonTheme,
    buttons: buttons,
    callToAction: callToAction,
    callToActionTypes: callToActionTypes,
    closedCaptionsElement: closedCaptionsElement,
    closedCaptionsMedia: closedCaptionsMedia,
    color: color,
    component: component,
    componentNames: componentNames,
    components: components,
    containerStyle: containerStyle,
    conversation: conversation,
    conversationMessage: conversationMessage,
    conversationMessages: conversationMessages,
    customFont: customFont,
    defaultMessage: defaultMessage,
    defaultMessageContent: defaultMessageContent,
    device: device,
    deviceScreen: deviceScreen,
    deviceScreens: deviceScreens,
    devices: devices,
    dropdownAlign: dropdownAlign,
    errors: errors,
    field: field,
    fieldDefinition: fieldDefinition,
    fieldDefinitions: fieldDefinitions,
    fields: fields,
    font: font,
    fontMedia: fontMedia,
    fontMedias: fontMedias,
    fonts: fonts,
    footer: footer,
    formControlSize: formControlSize,
    formErrors: formErrors,
    formField: formField,
    formFields: formFields,
    geoPosition: geoPosition,
    gridElement: gridElement,
    gridLayout: gridLayout,
    header: header,
    headingElement: headingElement,
    history: history,
    imageElement: imageElement,
    imageElementWithCaption: imageElementWithCaption,
    imageElements: imageElements,
    imageElementsWithCaption: imageElementsWithCaption,
    imageMedia: imageMedia,
    imageMedias: imageMedias,
    inputElement: inputElement,
    interaction: interaction,
    interactions: interactions,
    intl: intl,
    label: label,
    location: location,
    margin: margin,
    marker: marker,
    markerWithImage: markerWithImage,
    markers: markers,
    markersWithImage: markersWithImage,
    media: media,
    mediaFile: mediaFile,
    mediaTypes: mediaTypes,
    medias: medias,
    menuItem: menuItem,
    menuItems: menuItems,
    message: message,
    metadata: metadata,
    modal: modal,
    modals: modals,
    objectFit: objectFit,
    objectFitSize: objectFitSize,
    pageMetadata: pageMetadata,
    panel: panel,
    panels: panels,
    paymentItem: paymentItem,
    paymentItems: paymentItems,
    progress: progress,
    quizAnswer: quizAnswer,
    quizAnswers: quizAnswers,
    ref: ref,
    reload: reload,
    renderContext: renderContext,
    screen: screen,
    screenComponent: screenComponent,
    screenComponents: screenComponents,
    screenDefinition: screenDefinition,
    screenDefinitions: screenDefinitions,
    screenSize: screenSize,
    searchFilter: searchFilter,
    searchFilters: searchFilters,
    selectOption: selectOption,
    selectOptions: selectOptions,
    shadowType: shadowType,
    shareIncentive: shareIncentive,
    slide: slide,
    slides: slides,
    speaker: speaker,
    speakers: speakers,
    stackAlign: stackAlign,
    stackDirection: stackDirection,
    stackElement: stackElement,
    stackSpacing: stackSpacing,
    statusCode: statusCode,
    story: story,
    storyComponent: storyComponent,
    storyComponents: storyComponents,
    tag: tag,
    tags: tags,
    target: target,
    text: text,
    textAlign: textAlign,
    textElement: textElement,
    textStyle: textStyle,
    theme: theme,
    trackingVariables: trackingVariables,
    transition: transition,
    transitionName: transitionName,
    transitions: transitions,
    user: user,
    videoElement: videoElement,
    videoMedia: videoMedia,
    videoMedias: videoMedias,
    viewerTheme: viewerTheme,
    visitor: visitor,
    visualElement: visualElement,
    visualElements: visualElements
});

var sortedColors = function sortedColors(colors) {
  return sortBy(colors, ['color', 'alpha']);
};
var uniqueColors = function uniqueColors(colors) {
  return uniqWith(colors, function (colorA, colorB) {
    return colorA.alpha === colorB.alpha && colorA.color === colorB.color;
  });
};
var ColorsParser = /*#__PURE__*/function () {
  function ColorsParser(_ref) {
    var fieldsManager = _ref.fieldsManager,
      screensManager = _ref.screensManager;
    _classCallCheck(this, ColorsParser);
    this.fieldsManager = fieldsManager;
    this.screensManager = screensManager;
  }

  // Convert medias object to path
  _createClass(ColorsParser, [{
    key: "parse",
    value: function parse(story) {
      var _this = this;
      if (story === null) {
        return story;
      }
      var _ref2 = story || {},
        _ref2$theme = _ref2.theme,
        theme = _ref2$theme === void 0 ? null : _ref2$theme,
        _ref2$components = _ref2.components,
        components = _ref2$components === void 0 ? [] : _ref2$components;
      var _components$reduce = components.reduce(function (_ref3, screen) {
          var _ref3$colors = _ref3.colors,
            currentColors = _ref3$colors === void 0 ? null : _ref3$colors;
          var type = screen.type;
          var _ref4 = _this.screensManager.getDefinition(type) || {},
            _ref4$fields = _ref4.fields,
            fields = _ref4$fields === void 0 ? [] : _ref4$fields;
          var fieldsPattern = _this.getColorFieldPatterns(fields);
          var _ColorsParser$getColo = ColorsParser.getColorsFromPath(screen, fieldsPattern),
            newColors = _ColorsParser$getColo.colors;
          return {
            colors: [].concat(_toConsumableArray(currentColors), _toConsumableArray(newColors))
          };
        }, {
          colors: []
        }),
        colors = _components$reduce.colors;
      if (theme !== null) {
        var themeColors = this.parse(theme);
        return colors !== null || themeColors !== null ? uniqueColors([].concat(_toConsumableArray(sortedColors(themeColors || [])), _toConsumableArray(sortedColors(colors || [])))) : [];
      }
      return colors !== null ? sortedColors(uniqueColors(colors || [])) : [];
    }
  }, {
    key: "getColorFieldPatterns",
    value: function getColorFieldPatterns(fields) {
      var _this2 = this;
      var namePrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return fields.reduce(function (patterns, field) {
        var _field$name = field.name,
          name = _field$name === void 0 ? null : _field$name,
          _field$type = field.type,
          type = _field$type === void 0 ? null : _field$type;
        var path = [namePrefix, name].filter(function (it) {
          return it !== null;
        }).join('\\.');
        var fieldDefinition = _objectSpread(_objectSpread({}, type !== null ? _this2.fieldsManager.getDefinition(type) : null), field);
        // also check settings fields
        var _fieldDefinition$fiel = fieldDefinition.fields,
          subFields = _fieldDefinition$fiel === void 0 ? [] : _fieldDefinition$fiel,
          _fieldDefinition$item = fieldDefinition.itemsField,
          itemsField = _fieldDefinition$item === void 0 ? null : _fieldDefinition$item,
          _fieldDefinition$sett = fieldDefinition.settings,
          settings = _fieldDefinition$sett === void 0 ? [] : _fieldDefinition$sett;
        return [].concat(_toConsumableArray(patterns), _toConsumableArray(ColorsParser.fieldIsColor(fieldDefinition) ? [new RegExp("^".concat(path, "$"))] : []), _toConsumableArray(_this2.getColorFieldPatterns(subFields, path)), _toConsumableArray(_this2.getColorFieldPatterns(settings, path)), _toConsumableArray(itemsField !== null ? _this2.getColorFieldPatterns([itemsField], "".concat(path, "\\.[0-9]+")) : []));
      }, []);
    }
  }], [{
    key: "fieldIsColor",
    value: function fieldIsColor(_ref5) {
      var _ref5$id = _ref5.id,
        id = _ref5$id === void 0 ? null : _ref5$id;
      return id === 'color';
    }
  }, {
    key: "getColorsFromPath",
    value: function getColorsFromPath(data, patterns) {
      var colors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var keyPrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var dataIsArray = isArray(data);
      var keys = dataIsArray ? _toConsumableArray(data.keys()) : Object.keys(data);
      return keys.reduce(function (_ref6, key) {
        var currentData = _ref6.data,
          _ref6$colors = _ref6.colors,
          currentColors = _ref6$colors === void 0 ? null : _ref6$colors;
        var path = [keyPrefix, key].filter(function (it) {
          return it !== null;
        }).join('.');
        var patternMatch = patterns.reduce(function (found, pattern) {
          return found || pattern.test(path);
        }, false);
        var value = data[key];
        var color = null;
        var newValue = null;
        var subColors = null;
        if (patternMatch && isObject(value)) {
          if (value.color && value.color.length === 4) {
            var innerColor = value.color.split('').map(function (hex, i) {
              return i > 0 ? hex + hex : hex;
            }).join('').toUpperCase();
            color = {
              alpha: value.alpha || 1,
              color: innerColor
            };
          } else if (value.color) {
            color = {
              alpha: value.alpha,
              color: value.color.toUpperCase()
            };
          }
        } else if (isObject(value) || isArray(value)) {
          var subReturn = ColorsParser.getColorsFromPath(value, patterns, colors, path);
          newValue = subReturn.data;
          subColors = subReturn.colors;
        } else {
          newValue = value;
        }
        return {
          data: dataIsArray ? [].concat(_toConsumableArray(currentData || []), [newValue]) : _objectSpread(_objectSpread({}, currentData), {}, _defineProperty({}, key, newValue)),
          colors: color !== null ? [].concat(_toConsumableArray(currentColors || []), _toConsumableArray(subColors || []), [color]) : [].concat(_toConsumableArray(currentColors || []), _toConsumableArray(subColors || []))
        };
      }, {
        data: keys.length === 0 ? data : null,
        colors: colors
      });
    }
  }]);
  return ColorsParser;
}();

function pascalCaseTransform(input, index) {
  var firstChar = input.charAt(0);
  var lowerChars = input.substr(1).toLowerCase();
  if (index > 0 && firstChar >= "0" && firstChar <= "9") {
    return "_" + firstChar + lowerChars;
  }
  return "" + firstChar.toUpperCase() + lowerChars;
}
function pascalCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  return noCase(input, __assign({
    delimiter: "",
    transform: pascalCaseTransform
  }, options));
}

var getComponentFromName = function getComponentFromName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var components = arguments.length > 1 ? arguments[1] : undefined;
  var defaultComponent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (components === null || name === null) {
    return defaultComponent;
  }
  var pascalName = pascalCase(name);
  return components[pascalName] || components[name] || defaultComponent;
};

var ComponentsManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(ComponentsManager, _EventEmitter);
  var _super = _createSuper(ComponentsManager);
  function ComponentsManager() {
    var _this;
    var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ComponentsManager);
    _this = _super.call(this);
    _this.components = components;
    return _this;
  }
  _createClass(ComponentsManager, [{
    key: "addComponent",
    value: function addComponent(name, component) {
      var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return this.addComponents(_defineProperty({}, name, component), namespace);
    }
  }, {
    key: "addComponents",
    value: function addComponents(components) {
      var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var newComponents = namespace !== null ? Object.keys(components).reduce(function (componentsMaps, name) {
        return _objectSpread(_objectSpread({}, componentsMaps), {}, _defineProperty({}, "".concat(namespace, ".").concat(name), components[name]));
      }, {}) : components;
      this.components = _objectSpread(_objectSpread({}, this.components), newComponents);
      this.emit('change');
      return this;
    }
  }, {
    key: "merge",
    value: function merge(manager) {
      var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.addComponents(manager.getComponents(), namespace);
    }
  }, {
    key: "addNamespace",
    value: function addNamespace(namespace) {
      var _this2 = this;
      if (namespace === null) {
        return this;
      }
      this.components = Object.keys(this.components).reduce(function (componentsMap, name) {
        return _objectSpread(_objectSpread({}, componentsMap), {}, _defineProperty({}, "".concat(namespace, ".").concat(name), _this2.components[name]));
      }, {});
      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(name) {
      var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var components = this.getComponents(namespace);
      return getComponentFromName(name, components);
    }
  }, {
    key: "getComponents",
    value: function getComponents() {
      var _this3 = this;
      var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return namespace !== null ? Object.keys(this.components || {}).reduce(function (componentsMap, name) {
        var pattern = new RegExp("^".concat(namespace, "\\.(.*)$"));
        var matches = pattern.exec(name);
        return matches !== null ? _objectSpread(_objectSpread({}, componentsMap), {}, _defineProperty({}, matches[1], _this3.components[name])) : componentsMap;
      }, null) : this.components;
    }
  }, {
    key: "hasComponent",
    value: function hasComponent(name) {
      var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.components !== null && typeof this.components[namespace !== null ? "".concat(namespace, ".").concat(name) : name] !== 'undefined';
    }
  }]);
  return ComponentsManager;
}(EventEmitter);

var DefinitionsManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(DefinitionsManager, _EventEmitter);
  var _super = _createSuper(DefinitionsManager);
  function DefinitionsManager() {
    var _this;
    var definitions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, DefinitionsManager);
    _this = _super.call(this);
    _this.definitions = definitions || [];
    return _this;
  }
  _createClass(DefinitionsManager, [{
    key: "addDefinition",
    value: function addDefinition(definition) {
      this.addDefinitions(isArray(definition) ? definition : [definition]);
      return this;
    }
  }, {
    key: "addDefinitions",
    value: function addDefinitions(definitions) {
      this.definitions = uniqBy([].concat(_toConsumableArray(definitions), _toConsumableArray(this.definitions)), function (it) {
        return it.id;
      });
      this.emit('change');
      return this;
    }
  }, {
    key: "merge",
    value: function merge(manager) {
      return this.addDefinitions(manager.getDefinitions());
    }
  }, {
    key: "filter",
    value: function filter(_filter) {
      // this.definitions = this.definitions.filter(filter);
      // return this;
      return new DefinitionsManager(this.definitions.filter(_filter));
    }
  }, {
    key: "getDefinition",
    value: function getDefinition(id) {
      if (id === null) {
        return null;
      }
      return this.definitions.find(function (it) {
        return it.id === id;
      }) || null;
    }
  }, {
    key: "getDefinitions",
    value: function getDefinitions() {
      return this.definitions;
    }
  }, {
    key: "hasDefinition",
    value: function hasDefinition(id) {
      return this.getDefinition(id) !== null;
    }
  }, {
    key: "getComponent",
    value: function getComponent(id) {
      var _ref = this.getDefinition(id) || {},
        _ref$component = _ref.component,
        component = _ref$component === void 0 ? null : _ref$component;
      return component;
    }
  }, {
    key: "getComponents",
    value: function getComponents() {
      return this.definitions.reduce(function (allComponents, _ref2) {
        var id = _ref2.id,
          _ref2$component = _ref2.component,
          component = _ref2$component === void 0 ? null : _ref2$component;
        return component !== null ? _objectSpread(_objectSpread({}, allComponents), {}, _defineProperty({}, id, component)) : allComponents;
      }, {});
    }
  }]);
  return DefinitionsManager;
}(EventEmitter);

var EventsManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(EventsManager, _EventEmitter);
  var _super = _createSuper(EventsManager);
  function EventsManager(element) {
    var _this;
    _classCallCheck(this, EventsManager);
    _this = _super.call(this);
    _this.element = element;
    _this.events = {};
    _this.listeners = {};
    return _this;
  }
  _createClass(EventsManager, [{
    key: "subscribe",
    value: function subscribe(event, callback) {
      this.on(event, callback);
      this.events = _objectSpread(_objectSpread({}, this.events), {}, _defineProperty({}, event, [].concat(_toConsumableArray(this.events[event] || []), [callback])));
      if (this.events[event].length === 1) {
        this.addEventListener(event);
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(event, callback) {
      var _this2 = this;
      this.off(event, callback);
      this.events = Object.keys(this.events).reduce(function (newEvents, eventName) {
        if (eventName !== event) {
          return _objectSpread(_objectSpread({}, newEvents), {}, _defineProperty({}, eventName, _this2.events[eventName]));
        }
        var newListeners = _this2.events[eventName].filter(function (listener) {
          return listener !== callback;
        });
        return newListeners.length > 0 ? _objectSpread(_objectSpread({}, newEvents), {}, _defineProperty({}, eventName, newListeners)) : newEvents;
      }, {});
      if (typeof this.events[event] === 'undefined') {
        this.removeEventListener(event);
      }
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(event) {
      var _this3 = this;
      if (typeof this.listeners[event] === 'undefined') {
        this.listeners[event] = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return _this3.emit.apply(_this3, [event].concat(args));
        };
      }
      this.element.addEventListener(event, this.listeners[event]);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(event) {
      this.element.removeEventListener(event, this.listeners[event]);
    }
  }]);
  return EventsManager;
}(EventEmitter);

var FieldsManager = /*#__PURE__*/function (_DefinitionsManager) {
  _inherits(FieldsManager, _DefinitionsManager);
  var _super = _createSuper(FieldsManager);
  function FieldsManager() {
    _classCallCheck(this, FieldsManager);
    return _super.apply(this, arguments);
  }
  _createClass(FieldsManager, [{
    key: "filter",
    value: function filter(_filter) {
      return new FieldsManager(this.definitions.filter(_filter));
      // this.definitions = this.definitions.filter(filter);
      // return this;
    }
  }]);
  return FieldsManager;
}(DefinitionsManager);

var _excluded$4 = ["medias"],
  _excluded2$2 = ["medias"];
var MediasParser = /*#__PURE__*/function () {
  function MediasParser(_ref) {
    var fieldsManager = _ref.fieldsManager,
      screensManager = _ref.screensManager;
    _classCallCheck(this, MediasParser);
    this.fieldsManager = fieldsManager;
    this.screensManager = screensManager;
    this.fieldsPatternCache = {};
    this.parsedThemesCache = {};
  }
  _createClass(MediasParser, [{
    key: "getParsedStoryTheme",
    value: function getParsedStoryTheme(storyId, theme) {
      if (typeof this.parsedThemesCache[storyId] === 'undefined') {
        var _this$toPath = this.toPath(theme),
          themeMedias = _this$toPath.medias,
          newTheme = _objectWithoutProperties(_this$toPath, _excluded$4);
        this.parsedThemesCache[storyId] = {
          themeMedias: themeMedias,
          newTheme: newTheme
        };
      }
      return this.parsedThemesCache[storyId];
    }
  }, {
    key: "getFieldsPatternByScreen",
    value: function getFieldsPatternByScreen(type) {
      if (typeof this.fieldsPatternCache[type] === 'undefined') {
        var _ref2 = this.screensManager.getDefinition(type) || {},
          _ref2$fields = _ref2.fields,
          fields = _ref2$fields === void 0 ? [] : _ref2$fields;
        this.fieldsPatternCache[type] = this.getMediaFieldsPattern(fields);
      }
      return this.fieldsPatternCache[type];
    }

    // Convert medias object to path
  }, {
    key: "toPath",
    value: function toPath(story) {
      var _this = this;
      if (story === null) {
        return story;
      }
      var _ref3 = story || {},
        _ref3$id = _ref3.id,
        storyId = _ref3$id === void 0 ? null : _ref3$id,
        _ref3$theme = _ref3.theme,
        theme = _ref3$theme === void 0 ? null : _ref3$theme,
        _ref3$components = _ref3.components,
        components = _ref3$components === void 0 ? [] : _ref3$components;
      var _components$reduce = components.reduce(function (_ref4, screen) {
          var previousComponents = _ref4.components,
            currentMedias = _ref4.medias;
          var type = screen.type;
          var fieldsPattern = _this.getFieldsPatternByScreen(type);
          var _MediasParser$replace = MediasParser.replaceMediasWithPaths(screen, fieldsPattern),
            newScreen = _MediasParser$replace.data,
            newMedias = _MediasParser$replace.medias;
          return {
            components: [].concat(_toConsumableArray(previousComponents), [newScreen]),
            medias: _objectSpread(_objectSpread({}, currentMedias), newMedias)
          };
        }, {
          components: [],
          medias: null
        }),
        newComponents = _components$reduce.components,
        medias = _components$reduce.medias;
      if (theme !== null) {
        var _this$getParsedStoryT = this.getParsedStoryTheme(storyId, theme),
          themeMedias = _this$getParsedStoryT.medias,
          newTheme = _objectWithoutProperties(_this$getParsedStoryT, _excluded2$2);
        return medias !== null || themeMedias !== null ? _objectSpread(_objectSpread({}, story), {}, {
          theme: newTheme,
          components: newComponents,
          medias: _objectSpread(_objectSpread({}, themeMedias), medias)
        }) : story;
      }
      return medias !== null ? _objectSpread(_objectSpread({}, story), {}, {
        components: newComponents,
        medias: medias
      }) : story;
    }

    // Convert path to medias object
  }, {
    key: "fromPath",
    value: function fromPath(story) {
      var defaultMedias = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (story === null) {
        return story;
      }
      var _ref5 = story || {},
        _ref5$theme = _ref5.theme,
        theme = _ref5$theme === void 0 ? null : _ref5$theme,
        _ref5$components = _ref5.components,
        components = _ref5$components === void 0 ? [] : _ref5$components,
        _ref5$medias = _ref5.medias,
        medias = _ref5$medias === void 0 ? defaultMedias : _ref5$medias;
      if (medias === null && theme === null) {
        return story;
      }

      // Replace path with medias objects
      // const newComponents =
      //     medias !== null
      //         ? components.map((screen) => {
      //               const { type } = screen;
      //               const fieldsPattern = this.getFieldsPatternByScreen(type);
      //               return MediasParser.replacePathsWithMedias(screen, medias, fieldsPattern);
      //           })
      //         : components;

      // Faster parsing with data only
      var componentsPattern = MediasParser.getMediaPatternsFromData(components);
      var newComponents = medias !== null && componentsPattern.length > 0 ? MediasParser.replacePathsWithMedias(components, medias, componentsPattern) : components;

      // Replace path with medias object in theme
      if (theme !== null) {
        var newTheme = this.fromPath(theme, medias);
        return newTheme !== theme || newComponents !== components ? _objectSpread(_objectSpread({}, story), {}, {
          theme: newTheme,
          components: newComponents
        }) : story;
      }
      return newComponents !== components ? _objectSpread(_objectSpread({}, story), {}, {
        components: newComponents
      }) : story;
    }
  }, {
    key: "getMediaFieldsPattern",
    value: function getMediaFieldsPattern(fields) {
      var _this2 = this;
      var namePrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return fields.reduce(function (patterns, field) {
        var _field$name = field.name,
          name = _field$name === void 0 ? null : _field$name,
          _field$type = field.type,
          type = _field$type === void 0 ? null : _field$type;
        var path = [namePrefix, name].filter(function (it) {
          return it !== null;
        }).join('\\.');
        var fieldDefinition = _objectSpread(_objectSpread({}, type !== null ? _this2.fieldsManager.getDefinition(type) : null), field);

        // also check settings fields
        var _fieldDefinition$fiel = fieldDefinition.fields,
          subFields = _fieldDefinition$fiel === void 0 ? [] : _fieldDefinition$fiel,
          _fieldDefinition$item = fieldDefinition.itemsField,
          itemsField = _fieldDefinition$item === void 0 ? null : _fieldDefinition$item,
          _fieldDefinition$sett = fieldDefinition.settings,
          settings = _fieldDefinition$sett === void 0 ? [] : _fieldDefinition$sett;
        return [].concat(_toConsumableArray(patterns), _toConsumableArray(MediasParser.fieldIsMedia(fieldDefinition) ? [new RegExp("^".concat(path, "$"))] : []), _toConsumableArray(MediasParser.fieldIsFontFamily(fieldDefinition) ? [new RegExp("^".concat(path, "\\.media$")), new RegExp("^".concat(path, "\\.variants\\.[0-9]+\\.media$"))] : []), _toConsumableArray(_this2.getMediaFieldsPattern(subFields, path)), _toConsumableArray(_this2.getMediaFieldsPattern(settings, path)), _toConsumableArray(itemsField !== null ? _this2.getMediaFieldsPattern([itemsField], "".concat(path, "\\.[0-9]+")) : []));
      }, []);
    }
  }], [{
    key: "fieldIsMedia",
    value: function fieldIsMedia(_ref6) {
      var _ref6$media = _ref6.media,
        media = _ref6$media === void 0 ? false : _ref6$media;
      return media;
    }
  }, {
    key: "fieldIsFontFamily",
    value: function fieldIsFontFamily(_ref7) {
      var _ref7$id = _ref7.id,
        id = _ref7$id === void 0 ? null : _ref7$id;
      return id === 'font-family';
    }
  }, {
    key: "replacePathsWithMedias",
    value: function replacePathsWithMedias(data, medias, patterns) {
      var keyPrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var dataIsArray = isArray(data);
      return MediasParser.keys(data).reduce(function (newData, key) {
        var path = [keyPrefix, key].filter(function (it) {
          return it !== null;
        }).join('.');
        var patternMatch = patterns.reduce(function (found, pattern) {
          return found || pattern.test(path);
        }, false);
        var value = data[key];
        var newValue;
        if (patternMatch) {
          newValue = isObject(value) ? value : medias[value] || value;
        } else {
          newValue = isObject(value) || isArray(value) ? MediasParser.replacePathsWithMedias(value, medias, patterns, path) : value;
        }
        return dataIsArray ? [].concat(_toConsumableArray(newData), [newValue]) : _objectSpread(_objectSpread({}, newData), {}, _defineProperty({}, key, newValue));
      }, dataIsArray ? [] : {});
    }
  }, {
    key: "getMediaPath",
    value: function getMediaPath(_ref8) {
      var _ref8$id = _ref8.id,
        id = _ref8$id === void 0 ? null : _ref8$id;
      return id !== null ? "media://".concat(id) : null;
    }
  }, {
    key: "replaceMediasWithPaths",
    value: function replaceMediasWithPaths(data, patterns) {
      var medias = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var keyPrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var dataIsArray = isArray(data);
      var dataKeys = MediasParser.keys(data);
      return dataKeys.reduce(function (_ref9, key) {
        var currentData = _ref9.data,
          currentMedias = _ref9.medias;
        var path = [keyPrefix, key].filter(function (it) {
          return it !== null;
        }).join('.');
        var patternMatch = patterns.reduce(function (found, pattern) {
          return found || pattern.test(path);
        }, false);
        var value = data[key];
        var newValue;
        var media = null;
        var subMedias = null;
        if (patternMatch && isObject(value)) {
          var mediaPath = MediasParser.getMediaPath(value);
          newValue = mediaPath !== null ? mediaPath : value;
          media = mediaPath !== null ? value : null;
        } else if (isObject(value) || isArray(value)) {
          var subReturn = MediasParser.replaceMediasWithPaths(value, patterns, medias, path);
          newValue = subReturn.data;
          subMedias = subReturn.medias;
        } else {
          newValue = value;
        }
        return {
          data: dataIsArray ? [].concat(_toConsumableArray(currentData || []), [newValue]) : _objectSpread(_objectSpread({}, currentData), {}, _defineProperty({}, key, newValue)),
          medias: media !== null ? _objectSpread(_objectSpread(_objectSpread({}, currentMedias), subMedias), {}, _defineProperty({}, newValue, media)) : _objectSpread(_objectSpread({}, currentMedias), subMedias)
        };
      }, {
        data: dataKeys.length === 0 ? data : null,
        medias: medias
      });
    }
  }, {
    key: "getMediaPatternsFromData",
    value: function getMediaPatternsFromData(obj) {
      var dotObj = MediasParser.dot(obj);
      return Object.keys(dotObj).filter(function (key) {
        return isString(dotObj[key]) && dotObj[key].match(/^media:\/\/([^/]+)$/) !== null;
      }).map(function (it) {
        return new RegExp("^".concat(it, "$"));
      });
    }
  }, {
    key: "dot",
    value: function dot(obj) {
      return MediasParser.keys(obj).reduce(function (acc, key) {
        if (_typeof(obj[key]) !== 'object' || !obj[key]) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, obj[key]));
        }
        var flattenedChild = MediasParser.dot(obj[key]);
        return _objectSpread(_objectSpread({}, acc), MediasParser.keys(flattenedChild).reduce(function (childAcc, childKey) {
          return _objectSpread(_objectSpread({}, childAcc), {}, _defineProperty({}, "".concat(key, ".").concat(childKey), flattenedChild[childKey]));
        }, {}));
      }, {});
    }
  }, {
    key: "keys",
    value: function keys(obj) {
      return isArray(obj) ? _toConsumableArray(obj.keys()) : Object.keys(obj);
    }
  }]);
  return MediasParser;
}();

var ScreensManager = /*#__PURE__*/function (_DefinitionsManager) {
  _inherits(ScreensManager, _DefinitionsManager);
  var _super = _createSuper(ScreensManager);
  function ScreensManager() {
    _classCallCheck(this, ScreensManager);
    return _super.apply(this, arguments);
  }
  _createClass(ScreensManager, [{
    key: "getFields",
    value: function getFields(id) {
      var _ref = this.getDefinition(id) || {},
        _ref$fields = _ref.fields,
        fields = _ref$fields === void 0 ? null : _ref$fields;
      return fields;
    }
  }, {
    key: "getLayouts",
    value: function getLayouts(id) {
      var _ref2 = this.getDefinition(id) || {},
        _ref2$layouts = _ref2.layouts,
        layouts = _ref2$layouts === void 0 ? null : _ref2$layouts;
      return layouts;
    }
  }, {
    key: "filter",
    value: function filter(_filter) {
      return new ScreensManager(this.definitions.filter(_filter));
      // this.definitions = this.definitions.filter(filter);
      // return this;
    }
  }]);
  return ScreensManager;
}(DefinitionsManager);

var _excluded$3 = ["fonts"];
var FontsParser = /*#__PURE__*/function () {
  function FontsParser(_ref) {
    var fieldsManager = _ref.fieldsManager,
      screensManager = _ref.screensManager;
    _classCallCheck(this, FontsParser);
    this.fieldsManager = fieldsManager;
    this.screensManager = screensManager;
    this.fieldsPatternCache = {};
  }
  _createClass(FontsParser, [{
    key: "getFieldsPatternByScreen",
    value: function getFieldsPatternByScreen(type) {
      if (typeof this.fieldsPatternCache[type] === 'undefined') {
        var _ref2 = this.screensManager.getDefinition(type) || {},
          _ref2$fields = _ref2.fields,
          fields = _ref2$fields === void 0 ? [] : _ref2$fields;
        this.fieldsPatternCache[type] = this.getFieldsPattern(fields);
      }
      return this.fieldsPatternCache[type];
    }

    // Extract fonts
  }, {
    key: "parse",
    value: function parse(story) {
      var _this = this;
      if (story === null) {
        return story;
      }

      // Extract fonts from screen
      var _ref3 = story || {},
        _ref3$theme = _ref3.theme,
        theme = _ref3$theme === void 0 ? null : _ref3$theme,
        _ref3$components = _ref3.components,
        components = _ref3$components === void 0 ? [] : _ref3$components;
      var fonts = uniq(components.reduce(function (currentFonts, screen) {
        var type = screen.type;
        var fieldsPattern = _this.getFieldsPatternByScreen(type);
        var newFonts = FontsParser.extractFontsWithPaths(screen, fieldsPattern);
        return newFonts.length > 0 ? [].concat(_toConsumableArray(currentFonts), _toConsumableArray(newFonts)) : currentFonts;
      }, []), 'name');

      // Extract fonts from theme
      if (theme !== null) {
        var _this$parse = this.parse(theme),
          _this$parse$fonts = _this$parse.fonts,
          themeFonts = _this$parse$fonts === void 0 ? [] : _this$parse$fonts,
          newTheme = _objectWithoutProperties(_this$parse, _excluded$3);
        return fonts.length > 0 || themeFonts.length > 0 ? _objectSpread(_objectSpread({}, story), {}, {
          theme: newTheme,
          fonts: uniq([].concat(_toConsumableArray(themeFonts), _toConsumableArray(fonts)), 'name')
        }) : story;
      }
      return fonts.length > 0 ? _objectSpread(_objectSpread({}, story), {}, {
        fonts: fonts
      }) : story;
    }
  }, {
    key: "getFieldsPattern",
    value: function getFieldsPattern(fields) {
      var _this2 = this;
      var namePrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return fields.reduce(function (patterns, field) {
        var _field$name = field.name,
          name = _field$name === void 0 ? null : _field$name,
          _field$type = field.type,
          type = _field$type === void 0 ? null : _field$type;
        var path = [namePrefix, name].filter(function (it) {
          return it !== null;
        }).join('\\.');
        var fieldDefinition = _objectSpread(_objectSpread({}, type !== null ? _this2.fieldsManager.getDefinition(type) : null), field);

        // also check settings fields
        var _fieldDefinition$fiel = fieldDefinition.fields,
          subFields = _fieldDefinition$fiel === void 0 ? [] : _fieldDefinition$fiel,
          _fieldDefinition$item = fieldDefinition.itemsField,
          itemsField = _fieldDefinition$item === void 0 ? null : _fieldDefinition$item,
          _fieldDefinition$sett = fieldDefinition.settings,
          settings = _fieldDefinition$sett === void 0 ? [] : _fieldDefinition$sett;
        return [].concat(_toConsumableArray(patterns), _toConsumableArray(FontsParser.fieldIsFontFamily(fieldDefinition) ? [new RegExp("^".concat(path, "$"))] : []), _toConsumableArray(_this2.getFieldsPattern(subFields, path)), _toConsumableArray(_this2.getFieldsPattern(settings, path)), _toConsumableArray(itemsField !== null ? _this2.getFieldsPattern([itemsField], "".concat(path, "\\.[0-9]+")) : []));
      }, []);
    }
  }], [{
    key: "fieldIsFontFamily",
    value: function fieldIsFontFamily(_ref4) {
      var _ref4$id = _ref4.id,
        id = _ref4$id === void 0 ? null : _ref4$id;
      return id === 'font-family';
    }
  }, {
    key: "valueIsFont",
    value: function valueIsFont(_ref5) {
      var _ref5$type = _ref5.type,
        type = _ref5$type === void 0 ? null : _ref5$type;
      return type === 'custom' || type === 'google';
    }
  }, {
    key: "extractFontsWithPaths",
    value: function extractFontsWithPaths(data, patterns) {
      var keyPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var dataIsArray = isArray(data);
      var keys = dataIsArray ? _toConsumableArray(data.keys()) : Object.keys(data);
      return keys.reduce(function (currentFonts, key) {
        var path = [keyPrefix, key].filter(function (it) {
          return it !== null;
        }).join('.');
        var patternMatch = patterns.reduce(function (found, pattern) {
          return found || pattern.test(path);
        }, false);
        var value = data[key];
        var font = null;
        var subFonts = null;
        if (patternMatch && isObject(value) && FontsParser.valueIsFont(value)) {
          font = value;
        } else if (isObject(value) || isArray(value)) {
          subFonts = FontsParser.extractFontsWithPaths(value, patterns, path);
        }
        return subFonts !== null || font !== null ? [].concat(_toConsumableArray(currentFonts), _toConsumableArray(subFonts || []), _toConsumableArray(font !== null ? [font] : [])) : currentFonts;
      }, []);
    }
  }]);
  return FontsParser;
}();

var _excluded$2 = ["components"],
  _excluded2$1 = ["shareIncentive", "callToAction"];
var MigrationsParser = /*#__PURE__*/function () {
  function MigrationsParser(_ref) {
    var fieldsManager = _ref.fieldsManager,
      screensManager = _ref.screensManager;
    _classCallCheck(this, MigrationsParser);
    this.fieldsManager = fieldsManager;
    this.screensManager = screensManager;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(MigrationsParser, [{
    key: "parse",
    value: function parse(story) {
      if (story === null) {
        return story;
      }
      var _ref2 = story || {},
        _ref2$components = _ref2.components,
        components = _ref2$components === void 0 ? [] : _ref2$components,
        restStory = _objectWithoutProperties(_ref2, _excluded$2);
      var finalComponents = components.reduce(function (currentComponents, screen) {
        var _ref3 = screen || {},
          _ref3$shareIncentive = _ref3.shareIncentive,
          shareIncentive = _ref3$shareIncentive === void 0 ? null : _ref3$shareIncentive,
          _ref3$callToAction = _ref3.callToAction,
          callToAction = _ref3$callToAction === void 0 ? null : _ref3$callToAction,
          restScreen = _objectWithoutProperties(_ref3, _excluded2$1);
        if (shareIncentive === null && callToAction === null) {
          return [].concat(_toConsumableArray(currentComponents), [restScreen]);
        }
        var _ref4 = screen || {},
          _ref4$header = _ref4.header,
          header = _ref4$header === void 0 ? null : _ref4$header,
          _ref4$footer = _ref4.footer,
          footer = _ref4$footer === void 0 ? null : _ref4$footer;

        // Carful for recursivity here cause same key name
        var newHeader = shareIncentive !== null ? _objectSpread(_objectSpread({}, shareIncentive !== null ? {
          shareIncentive: shareIncentive
        } : null), header !== null ? {
          header: header
        } : null) : header;
        var newFooter = callToAction !== null ? _objectSpread(_objectSpread({}, callToAction !== null ? {
          callToAction: callToAction
        } : null), footer !== null ? {
          footer: footer
        } : null) : footer;
        var newScreen = _objectSpread(_objectSpread(_objectSpread({}, restScreen), newHeader !== null ? {
          header: newHeader
        } : null), newFooter !== null ? {
          footer: newFooter
        } : null);
        return [].concat(_toConsumableArray(currentComponents), [newScreen]);
      }, []);
      return _objectSpread(_objectSpread({}, restStory), {}, {
        components: finalComponents
      });
    }
  }]);
  return MigrationsParser;
}();

var _excluded$1 = ["textStyle", "color", "boxStyle"];
var ThemeParser = /*#__PURE__*/function () {
  function ThemeParser(_ref) {
    var screensManager = _ref.screensManager;
    _classCallCheck(this, ThemeParser);
    this.screensManager = screensManager;
    this.definitionCache = {};
    this.fieldsCache = {};
  }
  _createClass(ThemeParser, [{
    key: "getDefinitionByScreen",
    value: function getDefinitionByScreen(type, themeComponents) {
      if (typeof this.definitionCache[type] === 'undefined') {
        var definition = this.screensManager.getDefinition(type) || {};
        var themeScreen = themeComponents.find(function (it) {
          return it.type === type;
        }) || null;
        this.definitionCache[type] = {
          definition: definition,
          themeScreen: themeScreen
        };
      }
      return this.definitionCache[type];
    }
  }, {
    key: "getFieldsForDefinition",
    value: function getFieldsForDefinition(definition) {
      var _ref2 = definition || {},
        _ref2$id = _ref2.id,
        definitionId = _ref2$id === void 0 ? null : _ref2$id,
        _ref2$fields = _ref2.fields,
        fields = _ref2$fields === void 0 ? [] : _ref2$fields,
        _ref2$states = _ref2.states,
        states = _ref2$states === void 0 ? [] : _ref2$states;
      if (typeof this.fieldsCache[definitionId] === 'undefined') {
        if (states === null || states.length === 0) {
          this.fieldsCache[definitionId] = {
            fields: fields
          };
        } else {
          // TODO: test this
          var finalFields = fields;
          var repetableStates = [];
          if (states !== null && states.length > 0) {
            var nonRepetableStates = states.filter(function (_ref3) {
              var _ref3$repeatable = _ref3.repeatable,
                repeatable = _ref3$repeatable === void 0 ? false : _ref3$repeatable;
              return repeatable === false;
            });
            repetableStates = states.filter(function (_ref4) {
              var _ref4$repeatable = _ref4.repeatable,
                repeatable = _ref4$repeatable === void 0 ? false : _ref4$repeatable;
              return repeatable === true;
            });
            finalFields = nonRepetableStates.reduce(function (acc, it) {
              var _ref5 = it || {},
                _ref5$fields = _ref5.fields,
                itemFields = _ref5$fields === void 0 ? [] : _ref5$fields;
              if (itemFields !== null && itemFields.length > 0) {
                return acc.concat(itemFields);
              }
              return acc;
            }, finalFields);
          }
          this.fieldsCache[definitionId] = {
            fields: finalFields,
            repetableStates: repetableStates
          };
        }
      }
      return this.fieldsCache[definitionId];
    }
  }, {
    key: "parse",
    value: function parse(story) {
      var _this = this;
      if (story === null) {
        return story;
      }
      var _ref6 = story || {},
        _ref6$theme = _ref6.theme,
        theme = _ref6$theme === void 0 ? null : _ref6$theme,
        _ref6$components = _ref6.components,
        components = _ref6$components === void 0 ? null : _ref6$components;
      if (theme === null || components === null) {
        return story;
      }
      var _theme$components = theme.components,
        themeComponents = _theme$components === void 0 ? [] : _theme$components,
        _theme$background = theme.background,
        themeBackground = _theme$background === void 0 ? null : _theme$background,
        _theme$colors = theme.colors,
        themeColors = _theme$colors === void 0 ? {} : _theme$colors,
        _theme$textStyles = theme.textStyles,
        themeTextStyles = _theme$textStyles === void 0 ? null : _theme$textStyles,
        _theme$boxStyles = theme.boxStyles,
        themeBoxStyles = _theme$boxStyles === void 0 ? null : _theme$boxStyles;

      // Speed test
      // const newComponents = [...components];
      // for (let index = 0; index < components.length; index += 1) {
      //     const screen = components[index] || {};
      //     const { type } = screen;
      //     const { definition, themeScreen } = this.getDefinitionByScreen(type, themeComponents);
      //     const newScreen = this.parseScreen(
      //         definition,
      //         screen,
      //         themeScreen,
      //         themeBackground,
      //         themeColors,
      //         themeTextStyles,
      //         themeBoxStyles,
      //     );

      //     if (newScreen !== screen || themeScreen !== null) {
      //         newComponents[index] = {
      //             ...themeScreen,
      //             ...newScreen,
      //         };
      //     }
      // }
      // story.components = newComponents;
      // return story;

      var newComponents = components.reduce(function (currentComponents, screen, index) {
        var type = screen.type;
        var _this$getDefinitionBy = _this.getDefinitionByScreen(type, themeComponents),
          definition = _this$getDefinitionBy.definition,
          themeScreen = _this$getDefinitionBy.themeScreen;
        var newScreen = _this.parseScreen(definition, screen, themeScreen, themeBackground, themeColors, themeTextStyles, themeBoxStyles);

        // Only switch screen if it has changed
        return newScreen !== screen || themeScreen !== null ? [].concat(_toConsumableArray(currentComponents.slice(0, index)), [_objectSpread(_objectSpread({}, themeScreen), newScreen)], _toConsumableArray(currentComponents.slice(index + 1))) : currentComponents;
      }, components);
      return newComponents !== components ? _objectSpread(_objectSpread({}, story), {}, {
        components: newComponents
      }) : story;
    }
  }, {
    key: "parseScreen",
    value: function parseScreen(definition, value, themeValue, themeBackground, themeColors, themeTextStyles, themeBoxStyles) {
      var _this2 = this;
      var _this$getFieldsForDef = this.getFieldsForDefinition(definition),
        _this$getFieldsForDef2 = _this$getFieldsForDef.fields,
        fields = _this$getFieldsForDef2 === void 0 ? null : _this$getFieldsForDef2,
        _this$getFieldsForDef3 = _this$getFieldsForDef.repetableStates,
        repetableStates = _this$getFieldsForDef3 === void 0 ? null : _this$getFieldsForDef3;
      var newThemeValue = themeValue === null && themeBackground !== null ? {} : themeValue;
      if (themeBackground !== null && typeof newThemeValue.background !== 'undefined') {
        newThemeValue.background = _objectSpread(_objectSpread({}, themeBackground), newThemeValue.background);
      } else if (themeBackground !== null) {
        newThemeValue.background = themeBackground;
      }
      var newScreenValue = Object.keys(value).reduce(function (currentValue, key) {
        var repetableState = null;
        if (repetableStates !== null && repetableStates.length > 0) {
          repetableState = repetableStates.find(function (_ref7) {
            var _ref7$id = _ref7.id,
              stateId = _ref7$id === void 0 ? null : _ref7$id;
            return stateId !== null && stateId === key;
          }) || null;
        }
        var fieldDefinition = (fields || null).find(function (it) {
          return it.name === key;
        }) || repetableState || {};
        var fieldValue = value[key];
        var fieldThemeValue = newThemeValue !== null ? newThemeValue[key] || null : null;

        // Try for early return
        var _ref8 = fieldDefinition || {},
          _ref8$theme = _ref8.theme,
          theme = _ref8$theme === void 0 ? null : _ref8$theme;
        if ((theme === null || !isObject(theme)) && fields === null) {
          return _objectSpread(_objectSpread({}, currentValue), {}, _defineProperty({}, key, fieldValue));
        }

        // console.log('start', key, fieldValue);
        var newFieldValue = _this2.parseField(fieldValue, fieldDefinition, fieldThemeValue, themeColors, themeTextStyles, themeBoxStyles);
        // console.log('result', newFieldValue);

        // const newFieldValue = fieldValue;

        // Only switch field if it has changed
        return newFieldValue !== fieldValue ? _objectSpread(_objectSpread({}, currentValue), {}, _defineProperty({}, key, newFieldValue)) : currentValue;
      }, value);
      return newThemeValue !== null ? _objectSpread(_objectSpread({}, newThemeValue), newScreenValue) : newScreenValue;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "parseField",
    value: function parseField(value, fieldDefinition, themeValue, themeColors, themeTextStyles, themeBoxStyles) {
      var _this3 = this;
      var _fieldDefinition$them = fieldDefinition.theme,
        fieldTheme = _fieldDefinition$them === void 0 ? null : _fieldDefinition$them,
        _fieldDefinition$fiel = fieldDefinition.fields,
        definitionFields = _fieldDefinition$fiel === void 0 ? null : _fieldDefinition$fiel;

      // There are sub-fields in this definition
      if (definitionFields !== null && value !== null) {
        return isArray(value) ? value.map(function (innerFieldValue) {
          if (innerFieldValue === null) {
            return innerFieldValue;
          }
          return _this3.parseInnerFields(innerFieldValue, definitionFields, themeValue, themeColors, themeTextStyles, themeBoxStyles);
        }) : this.parseInnerFields(value, definitionFields, themeValue, themeColors, themeTextStyles, themeBoxStyles);
      }

      // Early return
      if (fieldTheme === null || !isObject(fieldTheme)) {
        return value;
      }

      // @TODO very slooow...
      if (isArray(value)) {
        var newFieldValue = value.map(function (innerField) {
          return innerField !== null ? Object.keys(innerField).reduce(function (newInnerField, innerFieldName) {
            // Early return
            if (!isObject(innerField[innerFieldName])) {
              return newInnerField;
            }
            var _ref9 = fieldTheme[innerFieldName] || {},
              _ref9$textStyle = _ref9.textStyle,
              innerFieldTextStyle = _ref9$textStyle === void 0 ? null : _ref9$textStyle,
              _ref9$color = _ref9.color,
              innerFieldColor = _ref9$color === void 0 ? null : _ref9$color,
              _ref9$boxStyle = _ref9.boxStyle,
              innerFieldBoxStyle = _ref9$boxStyle === void 0 ? null : _ref9$boxStyle;

            // Early return, no theme
            if (innerFieldTextStyle === null && innerFieldColor === null && innerFieldBoxStyle === null) {
              return newInnerField;
            }

            // Color
            var colorValue = innerFieldColor !== null ? {
              color: innerFieldColor !== null && themeColors !== null ? themeColors[innerFieldColor] || null : null
            } : null;

            // Text style
            var textStyleValue = innerFieldTextStyle !== null ? {
              textStyle: _objectSpread(_objectSpread({}, innerFieldTextStyle !== null && themeTextStyles !== null ? themeTextStyles[innerFieldTextStyle] || null : null), innerField[innerFieldName].textStyle || null)
            } : null;
            var boxStyleValue = innerFieldBoxStyle !== null ? {
              boxStyle: _objectSpread(_objectSpread({}, innerFieldBoxStyle !== null && themeBoxStyles !== null ? themeBoxStyles[innerFieldBoxStyle] || null : null), innerField[innerFieldName].boxStyle || null)
            } : null;
            if (colorValue === null && textStyleValue === null && boxStyleValue === null) {
              return newInnerField;
            }
            return _objectSpread(_objectSpread({}, newInnerField), {}, _defineProperty({}, innerFieldName, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, colorValue), innerField[innerFieldName]), textStyleValue), boxStyleValue)));
          }, innerField) : innerField;
        });
        return newFieldValue;
      }
      if (isObject(value)) {
        return this.parseValue(value, fieldTheme, themeValue, themeColors, themeTextStyles, themeBoxStyles);
      }
      return value;
    }
  }, {
    key: "parseInnerFields",
    value: function parseInnerFields(value, fieldsOrDefinition, themeValue, themeColors, themeTextStyles, themeBoxStyles) {
      var _this4 = this;
      var newValue = Object.keys(value).reduce(function (finalValue, innerFieldName) {
        var innerDefinition = isArray(fieldsOrDefinition) ? fieldsOrDefinition.find(function (it) {
          return it.name === innerFieldName;
        }) || null : fieldsOrDefinition;
        var _ref10 = innerDefinition || {},
          _ref10$theme = _ref10.theme,
          idfTheme = _ref10$theme === void 0 ? null : _ref10$theme;
        var innerValue = value[innerFieldName];

        // For items fields
        if (innerValue !== null && innerDefinition !== null && isArray(innerValue)) {
          // eslint-disable-next-line no-param-reassign
          finalValue[innerFieldName] = _this4.parseField(innerValue, innerDefinition, themeValue, themeColors, themeTextStyles, themeBoxStyles);
          return finalValue;
        }

        // For fields with fields
        if (innerValue !== null && idfTheme !== null && isObject(idfTheme) && isObject(innerValue)) {
          // eslint-disable-next-line no-param-reassign
          finalValue[innerFieldName] = _this4.parseValue(innerValue, idfTheme, themeValue, themeColors, themeTextStyles, themeBoxStyles);
          return finalValue;
        }

        // eslint-disable-next-line no-param-reassign
        finalValue[innerFieldName] = value[innerFieldName];
        return finalValue;
      }, {});
      return newValue;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "parseValue",
    value: function parseValue(initialValue, fieldTheme, themeValue, themeColors, themeTextStyles, themeBoxStyles) {
      var _this5 = this;
      if (isObject(initialValue) || isObject(fieldTheme)) {
        var value = initialValue || null;
        var _ref11 = fieldTheme || {},
          _ref11$textStyle = _ref11.textStyle,
          fieldTextStyleName = _ref11$textStyle === void 0 ? null : _ref11$textStyle,
          _ref11$color = _ref11.color,
          fieldColorName = _ref11$color === void 0 ? null : _ref11$color,
          _ref11$boxStyle = _ref11.boxStyle,
          fieldBoxStyleName = _ref11$boxStyle === void 0 ? null : _ref11$boxStyle,
          otherProps = _objectWithoutProperties(_ref11, _excluded$1);
        if (fieldTextStyleName === null && fieldColorName === null && fieldBoxStyleName === null && isEmpty(otherProps) && !isObject(fieldTheme)) {
          return value;
        }
        var complexValue = null;
        if (!isEmpty(otherProps)) {
          complexValue = Object.keys(otherProps).reduce(function (newObject, key) {
            var innerValue = value !== null ? value[key] || null : null;
            var newValue = _this5.parseValue(innerValue, otherProps[key], themeValue, themeColors, themeTextStyles, themeBoxStyles);
            return _objectSpread(_objectSpread({}, newObject), newValue !== null ? _defineProperty({}, key, newValue) : null);
          }, {});
        }
        var _ref13 = value || {},
          _ref13$textStyle = _ref13.textStyle,
          valueTextStyle = _ref13$textStyle === void 0 ? null : _ref13$textStyle,
          _ref13$boxStyle = _ref13.boxStyle,
          valueBoxStyle = _ref13$boxStyle === void 0 ? null : _ref13$boxStyle;

        // Color
        var fieldColor = fieldColorName !== null && themeColors !== null ? themeColors[fieldColorName] || null : null;
        var colorValue = fieldColor !== null ? {
          color: fieldColor
        } : null;

        // Text style
        var fieldTextStyle = fieldTextStyleName !== null && themeTextStyles !== null ? themeTextStyles[fieldTextStyleName] || null : null;
        var fieldThemeComponentTextStyle = themeValue !== null ? themeValue.textStyle || null : null;
        var textStyleValue = fieldTextStyle !== null || fieldThemeComponentTextStyle !== null ? {
          textStyle: _objectSpread(_objectSpread(_objectSpread({}, fieldTextStyle), fieldThemeComponentTextStyle), valueTextStyle || null)
        } : null;

        // Box style
        var fieldBoxStyle = fieldBoxStyleName !== null && themeBoxStyles !== null ? themeBoxStyles[fieldBoxStyleName] || null : null;
        var fieldThemeComponentBoxStyle = themeValue !== null ? themeValue.boxStyle || null : null;
        var boxStyleValue = fieldBoxStyle !== null || fieldThemeComponentBoxStyle !== null ? {
          boxStyle: _objectSpread(_objectSpread(_objectSpread({}, fieldBoxStyle), fieldThemeComponentBoxStyle), valueBoxStyle || null)
        } : null;

        // Only change value if something is overrided
        return colorValue !== null || themeValue !== null || textStyleValue !== null || boxStyleValue !== null || complexValue !== null ? _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, colorValue), themeValue), value), boxStyleValue), textStyleValue), complexValue) : value;
      }
      return initialValue;
    }
  }]);
  return ThemeParser;
}();

var StoryParser = /*#__PURE__*/function () {
  function StoryParser(_ref) {
    var screensManager = _ref.screensManager,
      fieldsManager = _ref.fieldsManager;
    _classCallCheck(this, StoryParser);
    this.themeParser = new ThemeParser({
      screensManager: screensManager
    });
    this.mediasParser = new MediasParser({
      screensManager: screensManager,
      fieldsManager: fieldsManager
    });
    this.fontsParser = new FontsParser({
      screensManager: screensManager,
      fieldsManager: fieldsManager
    });
    this.migrationsParser = new MigrationsParser({
      screensManager: screensManager,
      fieldsManager: fieldsManager
    });
  }
  _createClass(StoryParser, [{
    key: "parse",
    value: function parse(story) {
      var _this = this;
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$withTheme = _ref2.withTheme,
        withTheme = _ref2$withTheme === void 0 ? true : _ref2$withTheme,
        _ref2$withMedias = _ref2.withMedias,
        withMedias = _ref2$withMedias === void 0 ? true : _ref2$withMedias,
        _ref2$withFonts = _ref2.withFonts,
        withFonts = _ref2$withFonts === void 0 ? true : _ref2$withFonts,
        _ref2$withMigrations = _ref2.withMigrations,
        withMigrations = _ref2$withMigrations === void 0 ? true : _ref2$withMigrations;
      if (story === null) {
        return story;
      }
      var parsers = [[withMedias, function (newStory) {
        return _this.mediasParser.fromPath(newStory);
      }], [withTheme, function (newStory) {
        return _this.themeParser.parse(newStory);
      }], [withFonts, function (newStory) {
        return _this.fontsParser.parse(newStory);
      }], [withMigrations, function (newStory) {
        return _this.migrationsParser.parse(newStory);
      }]];
      return parsers.reduce(function (parsedStory, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          enabled = _ref4[0],
          parse = _ref4[1];
        return enabled ? parse(parsedStory) : parsedStory;
      }, story);
    }
  }]);
  return StoryParser;
}();

var _excluded = ["value"],
  _excluded2 = ["value", "currentTime"];
var Tracking = /*#__PURE__*/function (_BaseTracking) {
  _inherits(Tracking, _BaseTracking);
  var _super = _createSuper(Tracking);
  function Tracking() {
    var _this;
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Tracking);
    _this = _super.call(this, opts);
    var _this$options$variabl = _this.options.variables,
      variables = _this$options$variabl === void 0 ? null : _this$options$variabl;
    _this.variables = null;
    _this.screensViewed = [];
    if (variables !== null) {
      _this.setVariables(variables);
    }
    return _this;
  }
  _createClass(Tracking, [{
    key: "setVariables",
    value: function setVariables(variables) {
      this.variables = variables;
      if (variables !== null) {
        this.push(variables);
      }
    }
  }, {
    key: "getVariables",
    value: function getVariables() {
      return this.variables;
    }
  }, {
    key: "trackScreenView",
    value: function trackScreenView(screen, screenIndex) {
      var _ref = this.variables || {},
        _ref$screensCount = _ref.screensCount,
        screensCount = _ref$screensCount === void 0 ? null : _ref$screensCount;
      var _ref2 = screen || {},
        _ref2$id = _ref2.id,
        screenId = _ref2$id === void 0 ? null : _ref2$id,
        _ref2$type = _ref2.type,
        screenType = _ref2$type === void 0 ? null : _ref2$type,
        _ref2$metadata = _ref2.metadata,
        metadata = _ref2$metadata === void 0 ? {} : _ref2$metadata;
      var _ref3 = metadata || {},
        screenTitle = _ref3.title;
      if (this.screensViewed.indexOf(screenId || screenIndex) !== -1) {
        this.screensViewed = [].concat(_toConsumableArray(this.screensViewed), [screenId || screenIndex]);
      }
      var data = {
        event: 'screenView',
        screenId: screenId,
        screenType: screenType,
        screenIndex: screenIndex,
        screenTitle: screenTitle,
        screenProgress: screensCount !== null && screenIndex !== null ? (screenIndex + 1) / screensCount : null,
        screensViewed: this.screensViewed,
        screensViewedProgress: screensCount !== null ? this.screensViewed.length / screensCount : null
      };
      this.push(data);
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(category, action, label) {
      var _ref4 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref4$value = _ref4.value,
        value = _ref4$value === void 0 ? null : _ref4$value,
        opts = _objectWithoutProperties(_ref4, _excluded);
      var data = _objectSpread(_objectSpread({}, opts), {}, {
        event: 'eventInteraction',
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value
      });
      this.push(data);
    }
  }, {
    key: "trackMedia",
    value: function trackMedia(type, media, action) {
      var _ref5 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref5$value = _ref5.value,
        value = _ref5$value === void 0 ? null : _ref5$value,
        _ref5$currentTime = _ref5.currentTime,
        optsCurrentTime = _ref5$currentTime === void 0 ? null : _ref5$currentTime,
        opts = _objectWithoutProperties(_ref5, _excluded2);
      var _ref6 = media || {},
        _ref6$id = _ref6.id,
        mediaId = _ref6$id === void 0 ? null : _ref6$id,
        _ref6$name = _ref6.name,
        name = _ref6$name === void 0 ? null : _ref6$name,
        _ref6$duration = _ref6.duration,
        rootDuration = _ref6$duration === void 0 ? null : _ref6$duration,
        _ref6$currentTime = _ref6.currentTime,
        currentTime = _ref6$currentTime === void 0 ? optsCurrentTime : _ref6$currentTime,
        _ref6$metadata = _ref6.metadata,
        metadata = _ref6$metadata === void 0 ? {} : _ref6$metadata;
      var _ref7 = metadata || {},
        _ref7$duration = _ref7.duration,
        duration = _ref7$duration === void 0 ? rootDuration : _ref7$duration;
      var label = name;
      var data = _objectSpread(_objectSpread({}, opts), {}, {
        event: 'eventInteraction',
        eventCategory: type,
        eventAction: action,
        eventLabel: label,
        eventValue: value,
        mediaId: mediaId,
        mediaCurrentTime: currentTime !== null ? Math.round(currentTime) : null,
        mediaProgress: currentTime !== null && duration !== null && duration > 0 ? Math.round(currentTime / duration * 100) : null
      });
      this.push(data);
    }
  }]);
  return Tracking;
}(Tracking$1);

export { ColorsParser, ComponentsManager, DefinitionsManager, EventsManager, FieldsManager, FontsParser, MediasParser, PropTypes, ScreensManager, StoryParser, ThemeParser, Tracking };
